<template>
  <div
    v-if="view === 'image'"
    class="display-flex product image"
    :style="{pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? '0.3' : ''}"
    @click="!disabled ? onclick(product) : ''"
  >
    <img :src="img ? $anm22.getImagePath(img) : 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='"
      :class="[imgType]" >
    <div class="display-flex">
      <div class="com-anm22-app-text-l name">{{ product.langName }}</div>
      <div class="com-anm22-app-text-m desc">{{ product.langDescription }}</div>
      <div class="com-anm22-app-text-l price">
        {{ product.price.toFixed(2) + (product.pricingType === 2 ? ('/' + $anm22.tableClasses.foodUnitOfMeasurement().getById(product.uom)['typeClassLiteral']) : '')  }}
      </div>
    </div>
  </div>
  <div
    v-else
    :class="'wg-row product row' + (disabled ? ' disabled' : '')"
    :style="{
      opacity: (disabled ? '0.3' : '1'), 
    }"
    @click="!disabled ? onclick(product) : ''"
  >
    <img :src="img ? $anm22.getImagePath(img) : 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='">
    <div class="wg-row info">
      <div class="wg-col wg-xs-10">
        <div class="com-anm22-app-text-l">
          {{ product.langName }}
        </div>
        <div class="com-anm22-app-text-m" style="color:#999;margin-top:2px;">
          {{ product.langDescription }}
        </div>
      </div>
      <div class="wg-col wg-xs-2 display-flex" style="justify-content:flex-end;">
        <div class="com-anm22-app-text-m" style="color:#90A4AE;">
          <div class="com-anm22-app-text-m">
            {{ product.price.toFixed(2) + (product.pricingType === 2 ? ('/' + $anm22.tableClasses.foodUnitOfMeasurement().getById(product.uom)['typeClassLiteral']) : '') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    view: {
      type: String,
      default: 'list'
    },
    product: Object,
    onclick: {
      type: Function,
      default: () => {}
    },
    elements: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    disabled() {
      let qntCondition = false, qnt = 0;
      switch(this.product.stockType) {
        case 1:
          qntCondition = false;
          break;
        case 2:
          qnt = this.elements.filter(e => e.product === this.product.id).length;
          qntCondition = this.product.quantity <= 0 || qnt >= this.product.quantity;
          break;
        case 3:
          qnt = this.elements.filter(e => e.product === this.product.id).reduce((carry, e) => {
            return carry + e.weight;
          }, 0);
          qntCondition = this.product.quantity <= 0 || qnt >= this.product.quantity;
          break;
      }
      return this.product.status === 3 || qntCondition;
    },
    img() {
      return this.product.img
    },
    imgType() {
      return this.$anm22.getImagePath(this.img).indexOf(process.env.VUE_APP_BACK_DOMAIN + process.env.VUE_APP_BACK_BASE_URL + 'utilities/img/') === -1 ? 'custom-img' : '';
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../world/libs/anm22_web_graphics/v1/scss/_variables.scss";
.product {
  &.image {
    //border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
    margin: 5px;
    width: calc(50% - 10px);
    // height: 250px;
    background: #fff;
    box-sizing: border-box;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-around;
    img {
      width: 100%;
      height: 120px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      // background: #fef7f1;
      &.custom-img{
        padding:0;
        object-fit: cover;
        object-position: center;
      }
    }
    & > div {
      // height: 130px;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: space-around;
      align-content: space-around;
      padding: 5px;
      div {
        text-align: center;
        margin: 1px;
        // &.name {
        //   white-space: nowrap;
        //   overflow: hidden;
        //   text-overflow: ellipsis;
        // }
        &.desc {
          color:#999;
        }
        &.price {
          color:#90A4AE;
        }
      }
    }
  }
  &.row {
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    // border: 1px solid #ccc;
    margin-bottom: 10px;
    border-radius: 5px;
    min-height: 70px;
    padding: 0;
    flex-wrap: nowrap;
    align-items: center;
    cursor: pointer;
    img {
      height: 100%;
      width: 50px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      object-fit: cover;
      object-position: center;
    }
    div.info {
      height: 100%;
      padding: 10px 5px 10px 10px;
      flex-wrap: nowrap;
      align-items: center;
    }
  }
  cursor: pointer;
  transition: background-color 0.4s;
  .disabled {
    transition: none;
  }
  &:active {
    background-color: rgb(10, 171, 244) !important;
    transition: 0s;
  }
}
@media screen and (min-width: $dimMD) {
  .product {
    &.image {
      width: calc(33.33333% - 10px);
    }
  }
}
@media screen and (min-width: $dimLG) {
  .product {
    &.image {
      width: calc(25% - 10px);
    }
  }
}
</style>
